import {Routes} from '@angular/router';
import {loggedInGuard} from '~local/app/core/guards/logged-in.guard';
import {userDataExistsGuard} from '~local/app/core/guards/user-data-exists.guard';
import {entryRegistrationGuard} from '~local/app/core/guards/entry-registration.guard';
import {loggedOutGuard} from '~local/app/core/guards/logged-out.guard';
import {extract} from '~local/app/core/services/I18nService';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('~local/app/layout/authorized-layout/authorized-layout.component'),
        canActivateChild: [
            loggedInGuard,
            userDataExistsGuard,
        ],
        runGuardsAndResolvers: 'always',
        children: [
            {path: 'dashboard', loadChildren: () => import('app/pages/dashboard/dashboard-routes').then($ => $.routes)},
            {path: 'user', loadChildren: () => import('~local/app/pages/user/user-routes')},
            {
                path: 'verify-identity',
                loadComponent: () => import('app/pages/verify-identity/verify-Identity.component'),
                data: {title: extract('Verify Identity')}
            },
            // This is really wierd, but angular routing is working only with this
            {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
        ],
    },
    {
        path: '',
        loadComponent: () => import('~local/app/layout/unauthorized-layout/unauthorized-layout.component'),
        canActivateChild: [loggedOutGuard],
        runGuardsAndResolvers: 'always',
        children: [
            {path: 'login', loadComponent: () => import('app/pages/login/login.component')},
            {path: 'forgot-password', loadComponent: () => import('app/pages/forgot-password/forgot-password.component')},
            {
                path: 'register',
                loadComponent: () => import('app/pages/register/register.component'),
                canMatch: [entryRegistrationGuard]
            },
            {path: 'confirm/:action/:code', loadComponent: () => import('app/pages/callback-actions/callback-action.component')},
            // FIXME: Not sure if this should be under `LoggedOutGuardService`
            {path: 'reset-password/:code', loadComponent: () => import('app/pages/change-password/change-password.component')},
        ],
    },
    // Fallback when no prior route is matched
    {path: '**', redirectTo: '/dashboard', pathMatch: 'full'},
];
